//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Skeleton',
  props: {
    direction: {
      type: String,
      default: 'row'
    },
    showImageSkeleton: {
      type: Boolean,
      default: false
    },
    showImageOnly: {
      type: Boolean,
      default: false
    },
    showImageTitle: {
      type: Boolean,
      default: false
    },
    showPreviewImage: {
      type: Boolean,
      default: false
    },
    firstLineWidth: {
      type: Number,
      default: 100
    },
    secondLineWidth: {
      type: Number,
      default: 100
    },
    thirdLineWidth: {
      type: Number,
      default: 100
    },
    background: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      animated: true
    }
  }
}
